var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgParking(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 31,
    viewBox: "0 0 40 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.8024 21.8406H4.35193V4.94041C4.35193 2.76465 6.18687 1 8.4493 1H31.705C33.9675 1 35.8024 2.76465 35.8024 4.94041V21.8406Z",
    stroke: "#231F20",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.823 21.8405H7.33777V6.14845C7.33777 5.09851 8.21907 4.25098 9.31082 4.25098H30.85C31.9417 4.25098 32.823 5.09851 32.823 6.14845V21.8405Z",
    stroke: "#231F20",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.35191 21.8403H35.7958L38.7357 26.875C39.7288 28.1083 38.8146 29.9046 37.1901 29.9046H2.95762C1.33314 29.9046 0.418956 28.1083 1.41206 26.875L4.35191 21.8403Z",
    stroke: "#231F20",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.56104 25.8755H9.86983",
    stroke: "#231F20",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0199 25.8755H15.3287",
    stroke: "#231F20",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M19.472 25.8755H20.7808",
    stroke: "#231F20",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9308 25.8755H26.2396",
    stroke: "#231F20",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M30.3894 25.8755H31.6982",
    stroke: "#231F20",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0439 13.5293C21.0439 13.4661 21.0439 13.4091 21.0373 13.3522C21.0176 13.0233 21.1886 12.7071 21.4846 12.5426L21.5043 12.53C21.9318 12.2896 22.0831 11.7647 21.8331 11.3535L21.1097 10.1455C20.8598 9.73437 20.3139 9.5889 19.8864 9.82925L19.8667 9.8419C19.5839 10 19.2287 10 18.9525 9.82925C18.8275 9.75335 18.696 9.67745 18.5644 9.6142C18.2685 9.46873 18.0909 9.17146 18.0909 8.85521V8.82991C18.0909 8.35555 17.6897 7.96973 17.1965 7.96973H15.7364C15.2431 7.96973 14.842 8.35555 14.842 8.82991V8.85521C14.842 9.17146 14.6644 9.46873 14.3684 9.6142C14.2369 9.67745 14.1053 9.75335 13.9804 9.82925C13.7042 10 13.349 10 13.0662 9.8419L13.0465 9.82925C12.619 9.5889 12.0665 9.73437 11.8232 10.1455L11.0997 11.3535C10.8498 11.7647 11.0011 12.296 11.4286 12.53L11.4483 12.5426C11.7443 12.7071 11.9087 13.0233 11.8955 13.3522C11.8955 13.4091 11.8889 13.4724 11.8889 13.5293C11.8889 13.5862 11.8889 13.6495 11.8955 13.7064C11.9153 14.0353 11.7443 14.3516 11.4483 14.516L11.4286 14.5286C11.0011 14.769 10.8498 15.294 11.0997 15.7051L11.8232 16.9131C12.0731 17.3243 12.619 17.4697 13.0465 17.2294L13.0662 17.2167C13.349 17.0586 13.7042 17.0586 13.9804 17.2294C14.1053 17.3053 14.2369 17.3812 14.3684 17.4444C14.6644 17.5899 14.842 17.8872 14.842 18.2034V18.2287C14.842 18.7031 15.2431 19.0889 15.7364 19.0889H17.1899C17.6832 19.0889 18.0843 18.7031 18.0843 18.2287V18.2034C18.0843 17.8872 18.2619 17.5899 18.5579 17.4444C18.6894 17.3812 18.8209 17.3053 18.9459 17.2294C19.2221 17.0586 19.5773 17.0586 19.8601 17.2167L19.8798 17.2294C20.3073 17.4697 20.8598 17.3243 21.1031 16.9131L21.8266 15.7051C22.0765 15.294 21.9252 14.7627 21.4977 14.5286L21.478 14.516C21.182 14.3516 21.0176 14.0353 21.0308 13.7064C21.0439 13.6495 21.0439 13.5926 21.0439 13.5293Z",
    fill: "#106B46"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4335 15.2178C17.4033 15.2178 18.1895 14.4618 18.1895 13.5291C18.1895 12.5964 17.4033 11.8403 16.4335 11.8403C15.4637 11.8403 14.6775 12.5964 14.6775 13.5291C14.6775 14.4618 15.4637 15.2178 16.4335 15.2178Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6677 9.77881H29.186",
    stroke: "#106B46",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6677 13.5293H29.186",
    stroke: "#106B46",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6677 17.2866H29.186",
    stroke: "#106B46",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgParking);
export default __webpack_public_path__ + "static/media/parking.3ca7845a01bbebde4feaddc983d9d5bf.svg";
export { ForwardRef as ReactComponent };